'use strict';

import { StorageService } from "../../../vue/services/StorageService";

export default class SearchHistoryService {


    constructor() {
        this.ALL = 'ALL';
        this.types = [this.ALL, 'H', 'F', 'P'];
        this.settings = window.__pt;
        this.fn = window.__pt.fn;
        this.imageCache = new Map();

    }


    getRecentSearches(type = "ALL") {
        let items = this.get(type);
        let itemsLength = items.length;
        var itemMapped = [];
        for (var i = 0; i < itemsLength; i++) {

            let entry = items[i];
            let itemEntry = {};

            switch (entry.typeProduct) {

                case 'H':
                    itemEntry = this.hotelEntry(entry)
                    break;

                case 'F':
                    itemEntry = this.flightEntry(entry)
                    break;

                case 'P':
                    itemEntry = this.packageEntry(entry)
                    break;

                default:
            }


            if (itemEntry.type) {
                itemMapped.push(itemEntry);
            }
        }

        return itemMapped;
    }

    get(typeOriginal = "ALL") {
        const type = typeOriginal.toUpperCase();
        this.key = this.getKey();

        let currentHistory = StorageService.get(this.key) || [];

        const now = new Date().setHours(0, 0, 0, 0);

        currentHistory = currentHistory.filter(item => {
            const checkIn = item?.payload?.checkIn;
            return checkIn && +this.fn.getDate(checkIn) >= now;
        });

        StorageService.set(this.key, currentHistory);

        if (type === "ALL") {
            return currentHistory
                .sort((a, b) => b.createdAt - a.createdAt)
                .slice(0, 4)
                .map(i => i.payload);;
        }

        if (!this.validateType(type)) return [];
        return currentHistory
            .filter(i => i.type === type)
            .sort((a, b) => b.createdAt - a.createdAt)
            .slice(0, 4)
            .map(i => i.payload);;
    }

    set(payload, typeOriginal) {
        let type = typeOriginal.toUpperCase();
        if (!this.validateType(type)) return;

        this.key = this.getKey();

        let currentHistory = StorageService.get(this.key) || [];
        let newItem = this.getItemByProduct(payload, type);

        currentHistory = currentHistory.filter(i => i.id !== newItem.id);

        currentHistory.push(newItem);

        let itemsOfType = currentHistory.filter(i => i.type === type);

        if (itemsOfType.length > 4) {
            itemsOfType.sort((a, b) => a.createdAt - b.createdAt);
            const toKeep = itemsOfType.slice(-4);
            currentHistory = [
                ...currentHistory.filter(i => i.type !== type),
                ...toKeep
            ];
        }

        if (currentHistory.length > 12) {
            currentHistory.sort((a, b) => a.createdAt - b.createdAt);
            currentHistory = currentHistory.slice(-12);
        }
        StorageService.set(this.key, currentHistory);
    }

    getFirstEntry(typeOriginal = "P") {
        let items = this.get(typeOriginal);

        if (items && items.length) {
            let firstItem = items[0] || {};
            firstItem.img = "";
            return firstItem;
        }

        return null;
    }

    getHotel(typeOriginal = "H") {
        let items = this.get(typeOriginal);
        const uniqueItems = [];
        const seen = new Set();

        for (const item of items) {
            const uniqueKey = `${item.place_selected.id}_${item.place_selected.type}`;
            if (!seen.has(uniqueKey)) {
                seen.add(uniqueKey);
                uniqueItems.push(item);
            }
        }

        return uniqueItems;
    }

    getPackage(typeOriginal = "P") {
        let items = this.get(typeOriginal);

        const uniqueItems = {
            from: [],
            to: []
        };
        const arrivalSeen = new Set();
        const departureSeen = new Set();


        for (const item of items) {

            let uniqueKey = `${item.place_selected.placeCode}_${item.place_selected.placeId}`;
            if (!arrivalSeen.has(uniqueKey)) {
                arrivalSeen.add(uniqueKey);
                uniqueItems.from.push(item.place_selected);
            }

            uniqueKey = `${item.place_selected_to.placeCode}_${item.place_selected_to.placeId}`;
            if (!departureSeen.has(uniqueKey)) {
                departureSeen.add(uniqueKey);
                uniqueItems.to.push(item.place_selected_to);
            }
        }

        return uniqueItems;
    }

    getFlight(typeOriginal = "F") {
        let items = this.get(typeOriginal);

        const uniqueItems = {
            from: [],
            to: []
        };
        const arrivalSeen = new Set();
        const departureSeen = new Set();


        for (const item of items) {

            let uniqueKey = `${item.place_selected.code}`;
            if (!arrivalSeen.has(uniqueKey)) {
                arrivalSeen.add(uniqueKey);
                uniqueItems.from.push(item.place_selected);
            }

            uniqueKey = `${item.place_selected_to.code}`;
            if (!departureSeen.has(uniqueKey)) {
                departureSeen.add(uniqueKey);
                uniqueItems.to.push(item.place_selected_to);
            }
        }
        return uniqueItems;
    }

    createOrUpdateHotel(hotel, place, userSelection) {
        let items = this.get("H");

        let itemLength = items.length;
        let hotelId = hotel.hotelId;
        let imageHotel = hotel.gallery?.length ? hotel.gallery[0].cloudUri : "";

        for (var i = 0; i < itemLength; i++) {
            let entry = items[i];
            if (entry.typeProduct == "H" && entry.place_selected.code == hotelId && entry.img && entry.img.length == 0) {
                entry.img = imageHotel;
                this.set(entry, "H")
            }
        }
        const paxesInformation = this.getInputPaxes(userSelection.pax);
        const checkIn = this.fn.getDate(userSelection.checkIn);
        const checkOut = this.fn.getDate(userSelection.checkOut);

        var newItem = {
            checkIn: checkIn,
            checkOut: checkOut,
            img: imageHotel,
            paxes: userSelection.pax,
            paxes_name: paxesInformation.paxes_name,
            place_name: place.displayText,
            place_selected: {
                displayText: place.displayText,
                displayHtml: place.displayText,
                name: place.displayText,
                uri: place.uri,
                type: place.type,
                code: `${place.id}`,
                id: `${place.id}`,
                city: place.displayText,
                location: hotel.location && hotel.location.city && hotel.location.country ? `${hotel.location.city}, ${hotel.location.country}` : ""
            }
        }

        this.set(newItem, "H")

    }

    async createOrUpdateDestination(hotels, place, userSelection) {
        let items = this.get("H");

        let itemLength = items.length;
        let firstHotel = hotels[0];
        let productId = place.id;

        let url = this.getImageHotel(productId);
        let existItem = false;

        for (var i = 0; i < itemLength; i++) {
            let entry = items[i];

            if (entry.typeProduct == "H" && entry.place_selected.id == productId) {
                existItem = true;

                if (entry.img.length == 0) {
                    url = await this.getValidImageUrl(url, firstHotel);
                    entry.img = url;
                    this.set(entry, "H")
                }

                if (entry.img.length > 0) {
                    url = entry.img;
                }


            }
        }
        if (!existItem) {
            url = await this.getValidImageUrl(url, firstHotel);
        }

        const paxesInformation = this.getInputPaxes(userSelection.pax);
        const checkIn = this.fn.getDate(userSelection.checkIn);
        const checkOut = this.fn.getDate(userSelection.checkOut);

        var newItem = {
            checkIn: checkIn,
            checkOut: checkOut,
            img: url,
            paxes: userSelection.pax,
            paxes_name: paxesInformation.paxes_name,
            place_name: place.displayText,
            place_selected: {
                displayText: place.displayText,
                displayHtml: place.displayText,
                name: place.displayText,
                uri: place.uri,
                type: place.type,
                code: `${place.id}`,
                id: `${place.id}`,
                city: place.name,
                location: place.displayText
            }
        }

        this.set(newItem, "H")

    }

    validateType(type) {
        return this.types.includes(type);
    }

    getItemByProduct(payload, type) {
        const id = this.getID(payload, type);
        payload.typeProduct = type;
        payload.img = payload.img && payload.img.length ? payload.img : "";

        return {
            id,
            type,
            createdAt: Date.now(),
            payload
        };
    }

    getID(payload, type) {
        let id = "";
        let paxStr = "";
        switch (type) {
            case 'H':
                paxStr = JSON.stringify(payload.paxes);
                let idPlace = +payload.place_selected.code && payload.place_selected.code.length > 4 ? payload.place_selected.code : payload.place_selected.id;
                id = `${type}_id:${payload.place_selected.uri}_${+this.fn.getDate(payload.checkIn)}_${+this.fn.getDate(payload.checkOut)}_p:${paxStr}`;
                break;
            case 'F':
                paxStr = JSON.stringify(payload.paxes);
                id = `${type}_id:${payload.place_selected.id}_${payload.place_selected_to.id}_${+payload.checkIn}_${+payload.checkOut}_p:${paxStr}_m:${+payload.mode}`;
                break;
            case 'P':
                paxStr = JSON.stringify(payload.paxes);
                id = `${type}_id:${payload.place_selected.placeId}:${payload.place_selected.placeCode}_${payload.place_selected_to.placeId}:${payload.place_selected_to.placeCode}_${+payload.checkIn}_${+payload.checkOut}_p:${paxStr}`;
                break;
        }
        return id;
    }

    hotelEntry(entry) {
        let startDate = this.fn.getDate(entry.checkIn);
        let endDate = this.fn.getDate(entry.checkOut);

        let itemIdPath = entry.place_selected.type == 14 ? `_a${entry.place_selected.code || entry.place_selected.id}` : `_d${entry.place_selected.id}`;
        let path = this.getPathHotel(entry.place_selected.type);

        let paxQuery = this.fn.mapPaxToUrl(entry.paxes);

        let data = {
            adults: entry.adults,
            checkin: this.fn.formatDate(startDate, this.settings.settings.formatDate),
            checkout: this.fn.formatDate(endDate, this.settings.settings.formatDate),
        };

        let query = this.fn.objectToQueryParams({ ...data, ...paxQuery });

        return {
            image: entry.img && entry.img.length ? entry.img : this.getImageHotel(entry.place_selected.id),
            icon: "//img.cdnpth.com/media/assets/img/Hotel_icon.svg?tx=w_15,h_15,c_fill",
            name: entry.place_name,
            description: entry.place_name,
            startDate: startDate,
            endDate: endDate,
            paxInfo: entry.paxes_name.includes(',')
                ? entry.paxes_name.split(',').slice(0, -1).join(',')
                : entry.paxes_name,
            title: this.settings.ln.hotel_lang,
            url: `${this.settings.settings.site.siteUrl}${path}${entry.place_selected.uri}${itemIdPath}?${query}`,
            type: entry.typeProduct,
            mode: !!(startDate && endDate),
        };
    }

    flightEntry(entry) {

        let startDate = this.fn.getDate(entry.checkIn);
        let endDate = this.fn.getDate(entry.checkOut);
        let paxQuery = this.mapFlightPaxQuery(entry.paxes);
        let data = {
            startingFromAirport: entry.place_selected.code,
            returningFromAirport: entry.place_selected_to.code,
            startingFromDateTime: this.fn.formatDate(startDate, this.settings.settings.formatDate),
            returningFromDateTime: this.fn.formatDate(endDate, this.settings.settings.formatDate),
            tripMode: entry.mode,
            mode: entry.mode,
            originName: entry.place_name,
            destinationName: entry.place_name_to
        };


        let query = this.fn.objectToQueryParams({ ...data, ...paxQuery });
        let languageType = entry.mode ? 'flight_round' : 'flight_one_way';

        return {
            image: entry.img && entry.img.length ? entry.img : `//img.cdnpth.com/media/assets/recent-search-imgs/iatas/${entry.place_selected_to.code}.jpg?tx=w_100,h_100,g_auto,c_fill`,
            icon: "//img.cdnpth.com/media/assets/img/Vuelo_redondo_icon.svg?tx=w_15,h_15,c_fill",
            title: this.settings.ln[`${languageType}_${this.settings.settings.site.siteName}`],
            name: entry.place_selected_to.displayText,
            description: `${entry.place_selected.displayText} ${this.settings.ln.to} ${entry.place_selected_to.displayText}`,
            startDate: startDate,
            endDate: endDate,
            paxInfo: entry.paxes_name,
            mode: entry.mode,
            url: `${this.settings.settings.site.siteUrl}${this.settings.settings.site.pathFlight}?${query}`,
            type: entry.typeProduct
        };
    }

    packageEntry(entry) {

        let startDate = this.fn.getDate(entry.checkIn);
        let endDate = this.fn.getDate(entry.checkOut);

        let paxQuery = this.mapPackagePaxQuery(entry.paxes);

        let data = {
            startingFromDateTime: this.fn.formatDate(startDate, this.settings.settings.formatDate),
            returningFromDateTime: this.fn.formatDate(endDate, this.settings.settings.formatDate),
            checkIn: this.fn.formatDate(startDate, this.settings.settings.formatDate),
            checkOut: this.fn.formatDate(endDate, this.settings.settings.formatDate),
            startingFromAirport: entry.place_selected.placeCode,
            returningFromAirport: entry.place_selected_to.placeCode,
            startingPlaceId: entry.place_selected.placeId,
            returningPlaceId: entry.place_selected_to.placeId
        };

        let query = this.fn.objectToQueryParams({ ...data, ...paxQuery });

        let pathName = entry.packageHotelDetail && entry.packageHotelDetail.length ? entry.packageHotelDetail : this.settings.settings.site.pathPackages;

        return {
            image: entry.img && entry.img.length ? entry.img : `//img.cdnpth.com/media/assets/recent-search-imgs/iatas/${entry.place_selected_to.placeCode}.jpg?tx=w_100,h_100,g_auto,c_fill`,
            icon: "//img.cdnpth.com/media/assets/img/Hotel_mas_avion_icons.svg",
            title: this.settings.ln.package_lang,
            name: entry.place_selected_to.placeDescription,
            description: `${entry.place_selected.placeDescription} ${this.settings.ln.to} ${entry.place_selected_to.placeDescription}`,
            startDate: startDate,
            endDate: endDate,
            paxInfo: entry.paxes_name,
            url: `${this.settings.settings.site.siteUrl}${pathName}?${query}`,
            type: entry.typeProduct
        };
    }

    //*Estatico
    getLandingPagePath(tab) {
        let page = '';
        tab = tab.replace(`/${this.settings.culture.cultureCode}`, "");;

        switch (tab) {
            case "/vuelos":
                page = 'F';
                break;

            case "/flights":
                page = 'F';
                break;

            case "/paquetes":
                page = 'P';
                break;

            case "/packages":
                page = 'P';
                break;

            case "/hoteles":
                page = 'H';
                break;

            case "/hotels":
                page = 'H';
                break;

            default:
                page = "ALL";
                break;
        }

        return page;
    }

    getPathHotel(type) {
        let uri = this.settings.settings.site.pathHome;
        switch (type) {
            case 6:
                uri = this.settings.settings.site.pathHoteles;
                break;
            case 3:
                uri = this.settings.settings.site.pathHoteles;
                break;
            case 11:
                uri = this.settings.settings.site.pathHoteles;
                break;
            case 7:
                uri = this.settings.settings.site.pathHoteles;
                break;
            case 14:
                uri = this.settings.settings.site.pathHotelDetail;
                break;
            case 12:
                uri = this.settings.settings.site.pathHoteles;
                break;
        }

        return uri;
    }

    mapFlightPaxQuery(pax) {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let infants = 0;
        let agekids = [];
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];
            adults += room.adults;
            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                kids += 1;
            }

        }
        paxesKeys[`adults`] = adults;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");


        return paxesKeys;
    }

    mapPackagePaxQuery(pax) {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let infants = 0;
        let agekids = [];
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];
            let position = i + 1;

            paxesKeys[`room${position}.adults`] = room.adults;
            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                if (childrenRoom.year > 5) {
                    kids += 1;
                } else {
                    infants += 1;
                }
            }
            paxesKeys[`room${position}.kids`] = childrens;
            paxesKeys[`room${position}.agekids`] = childreJoin.join(",");

        }
        paxesKeys[`rooms`] = rooms;
        paxesKeys[`adults`] = adults;
        paxesKeys[`infants`] = infants;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");


        return paxesKeys;
    }

    getInputPaxes(paxes) {
        let adults = 0;
        let children = 0;
        let isOldVersion = Array.isArray(paxes);
        let paxesEntry = {};


        if (isOldVersion) {
            for (const room of paxes) {
                adults += room.adults || 0;
                children += room.children ? room.children.length : 0;
            }
        } else if (typeof paxes === "object") {
            adults = paxes.adults || 0;
            children = paxes.children ? paxes.children.length : 0;
        }

        const lengthPax = isOldVersion ? paxes.length : paxes.rooms;
        const roomTitle = lengthPax === 1 ? this.settings.ln.room : this.settings.ln.rooms;
        const adultsTitle = adults === 1 ? this.settings.ln.adult : this.settings.ln.adults;
        const childrenTitle = children === 1 ? this.settings.ln.child : this.settings.ln.children;

        let childrenText = "";
        if (children > 0) {
            childrenText = ` ${children} ${childrenTitle}, `;
        }

        paxesEntry.paxes_name = `${adults} ${adultsTitle},${childrenText} ${lengthPax} ${roomTitle}`;
        paxesEntry.paxes_people = `${adults + children} ${this.settings.ln.new_pers} ${lengthPax} ${this.settings.ln.new_room}`;
        paxesEntry.capacityTotal = adults + children;

        return paxesEntry;
    }

    getImageHotel(id) {
        return `//img.cdnpth.com/media/assets/recent-search-imgs/places/${id}.jpg`
    }

    getKey() {
        return `history_${this.settings.culture.cultureCode}`
    }
    async getValidImageUrl(url, fallbackHotel) {
        let exists;
        if (this.imageCache.has(url)) {
            exists = this.imageCache.get(url);
        } else {
            exists = await this.imageExists(url);
            this.imageCache.set(url, exists);
        }

        if (!exists) {
            url = fallbackHotel?.mainPhoto?.cloudUri || "";
        }
        return url;
    }

    async imageExists(url) {
        try {
            const res = await fetch(url, { method: 'HEAD' });
            return res.ok;
        } catch {
            return false;
        }
    }
}

export const SearchHistory = new SearchHistoryService();